/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PublishBotExamViewModel } from "../types/PublishBotExamViewModel.ts";

export const publishBotExamViewModelSchema = z.object({
  botExamId: z.optional(
    z.number().int().describe("ID da prova bot a ser publicada."),
  ),
  startDate: z
    .string()
    .datetime()
    .describe(
      "Data e hora de início da disponibilização da prova bot aos alunos. Opcional.",
    )
    .nullish(),
  endDate: z
    .string()
    .datetime()
    .describe(
      "Data e hora de encerramento da disponibilização da prova bot aos alunos. Opcional.",
    )
    .nullish(),
  weight: z.optional(
    z
      .number()
      .int()
      .describe(
        "Peso da prova bot na composição da nota final da disciplina. Padrão: 1.",
      ),
  ),
  randomize: z.optional(
    z
      .boolean()
      .describe(
        "Define se as questões da prova bot serão apresentadas em ordem aleatória. Padrão: true.",
      ),
  ),
  percentualComplexity: z.optional(
    z
      .number()
      .int()
      .describe(
        "Percentual de questões complexas incluídas na prova bot. Valor entre 0 e 100.",
      ),
  ),
  recommendedToDoOnPortal: z.optional(
    z
      .boolean()
      .describe(
        "Define se a prova bot é recomendada para ser realizada pelo portal.",
      ),
  ),
  enableSafeEvaluationMode: z.optional(
    z
      .boolean()
      .describe(
        "Define se o modo de avaliação segura está habilitado para a prova bot.",
      ),
  ),
  maxScreenExitsAllowed: z
    .number()
    .int()
    .describe(
      "Número máximo de saídas de tela permitidas durante a realização no modo seguro. Opcional.",
    )
    .nullish(),
  enableBlockUnauthorizedActions: z.optional(
    z
      .boolean()
      .describe(
        "Define se ações não autorizadas (ex: copiar, colar) serão bloqueadas durante a realização da prova bot.",
      ),
  ),
  tries: z.optional(
    z
      .number()
      .int()
      .describe("Número máximo de tentativas permitidas para a prova bot."),
  ),
  time: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tempo máximo em minutos para realização da prova bot. `0` indica sem limite de tempo.",
      ),
  ),
  teacherEvaluationExamId: z
    .number()
    .int()
    .describe(
      "ID da prova de avaliação do professor vinculada à prova bot. Opcional.",
    )
    .nullish(),
  isExtraTryAllowed: z.optional(
    z
      .boolean()
      .describe(
        "Define se o aluno terá direito a tentativa extra na prova bot.",
      ),
  ),
  isOnDemand: z.optional(
    z
      .boolean()
      .describe(
        "Define se a prova bot será disponibilizada no formato on demand.",
      ),
  ),
}) as unknown as ToZod<PublishBotExamViewModel>;
